/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 10/02/22
 */

import { DependencyList, useEffect, useLayoutEffect } from 'react';

/**
 * Passthrough hook to allow use of an async effect without wrapper
 * @param callback
 * @param dependencies
 */
export const useAsyncEffect = (callback: () => void, dependencies: DependencyList): void => {
    useEffect(() => {
        (async () => {
            await callback();
        })();
    }, dependencies);
};

/**
 * Passthrough hook to allow use of an async layout effect without wrapper
 * @param callback
 * @param dependencies
 */
export const useAsyncLayoutEffect = (callback: () => void, dependencies: DependencyList): void => {
    useLayoutEffect(() => {
        (async () => {
            await callback();
        })();
    }, dependencies);
};
